// extracted by mini-css-extract-plugin
export default {"container":"mp-z","ratingLayout":"np-z","ratingLabel":"op-z","nonInteractiveRatingLabel":"pp-z"};